import { useContext } from "react";
import { PageThemeContext } from "./PageThemeProvider";

export const usePageTheme = () => {
  const theme = useContext(PageThemeContext);
  return {
    themeId: theme.id,
    tokens: theme.tokens,
    preview: theme.preview,
    theme,
  };
};
